<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="A" itemcode="A-QBLY"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">楼宇</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">全部楼宇库</span>
							<input type="text" placeholder="请输入楼宇名称" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> 
					</div> 
					<div class="opport-screen-list1">  
						<dl class="opport-screen bdbe">
							<dt class="fl">区域</dt>
							<dd class="fl"> 
								<span :key="index" v-for="(item,index) in countyData"	@click="areaChoosed(item);"	:class="item.county == countyid?'a-screen current' : 'a-screen'">{{item.countyName}}</span>
							</dd>
						</dl> 
						<dl class="opport-screen bdbe" v-show="streetData.length>0">
							<dt class="fl">位置</dt>
							<dd class="fl"> 
								<span @click="streetChoosed({id:0});"	 :class="0 == streetId?'a-screen current' : 'a-screen'">全部</span>
								<span v-for="(item,index) in streetData" :key="index"	@click="streetChoosed(item);"	:class="item.id == streetId?'a-screen current' : 'a-screen'">{{item.name}} </span>
							</dd>
						</dl>
					</div>
				</div> 
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" style="width: 95%; " v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<!-- <div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
							</div> -->
					</div>  
					 <!-- v-show="enterpristlist.length!=0" -->
					<div class="enterprise_list_box"> 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th class="xuhaotd">排序</th>
								<th>楼宇名称</th>
								<th  v-for="(list,index) in dimesmlist" :key="index" >
									<div @click="tablesort(list.type);" :style="'width:'+list.name.length*16+'px'" :class="{'td_sortname ':true,'current':orderField == list.type}" >
										<span	:class="{'sortname ':true,'current':orderType == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
									</div> 
									</th>
									<th>地址</th>
							</tr> 
							<!--  v-for="(list,index) in enterpristlist" -->
							<tr v-for="(list,index) in enterpristlist" :key="index">
								 <td>{{(page-1)*pageSize+index+1}}</td>
								 <td class="title" @click="routerlinkid('/building',list.id)">{{list.title}}</td>
								 <td>{{list.enterpriseNum}}</td> 
								 <td>{{list.a090101}}</td>
								 <td>{{list.a090201}}</td>
								 <td>{{list.a020104}}</td>
								 <td>{{list.a080101}}</td>
								 <td>{{list.a090103}}</td>
								 <td>{{list.a080118}}</td> 
								 <td>{{list.moveIn}}</td>
								 <td>{{list.moveOut}}</td>
								 <td>{{emptyStr(list.address)}}</td>
							</tr>
						</table> 
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="getCompanyList"></zpagenav>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出列表弹框 -->
		<div class="enlistexportPop" v-show="exportpop">
			<div class="enlistexportPop_box">
				<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
				<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
				<span class="closebtn" @click="exportpop=false"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div> 
</template>

<script> 
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'allBuildings',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "全部楼宇",
				searchPlaceholder:'全部楼宇库', industrytype:1,
				areaData:[],
				countyData:[{county:0,countyName:"全深圳"}],
				areaId:0,
				streetData:[],
				streetId:0,
				countyid:0,
				dimesmlist:[{
					name: '在营企业数',
					type: 0
				}, {
					name: '独角兽',
					type: 6
				}, {
					name: '上市公司',
					type: 7
				}, {
					name: '国有企业',
					type: 8
				}, {
					name: '专精特新',
					type: 9
				}, {
					name: '专精特新小巨人',
					type: 10
				}, {
					name: '创新型中小型企业',
					type: 11
				}, {
					name: '今年迁入',
					type: 4
				}, {
					name: '今年迁出',
					type: 5
				},], 
				hotindustry:[],hotindustrychild:[], industrycode1:"",industrycode2:'',industryid:0, 
				userdata: {}, 
				enterpristlist: [],  
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数    
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序    
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '', 
				
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				//外资企业筛选列表：0=注册资本,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
			 
			  
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', true);
		},  
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			
			this.getuserinfor(); 
		},
		mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
			// console.log('sercatype:', this.searchtype); 
			this.getStreetData();

		},
		methods: {  
			//位置区域选择选择
			areaChoosed(item) {
				this.countyid=item.county;
				this.streetData=this.areaData.filter(list=>{
					return list.county==item.county;
				});
				this.streetChoosed({id:0});
			},
			streetChoosed(list){
				this.streetId=list.id; 
				this.getCompanyList();
			},
			//获取区域街道信息
			getStreetData(){
				var ajaxurl = this.$api.park.building.areaList();
				var _this = this;
				console.log(ajaxurl,this.userdata.token)
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
				 console.log(res.data.list) 
					_this.areaData=res.data.list;
					let str="",data=res.data.list;
					for(var i=0;i<data.length;i++){
						if(str.indexOf(data[i].countyName)<0){
							str+=data[i].countyName;
							_this.countyData.push({countyName:data[i].countyName,county:data[i].county})
						}  
					}
					_this.streetData=[];  
					_this.getCompanyList();
				}).catch(function(error) {});
			
			},  
 
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getCompanyList();
			},
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getCompanyList();
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			}, 
			//获取用户信息
			getuserinfor() {
				let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage
					.getItem('userData');
				if (typeof(dataddd) == 'object') {
					this.userdata = dataddd;
				} else {
					this.userdata = JSON.parse(dataddd);
				} 
			}, 
			// pageHandler: function(page) { 
			// 	console.log('pageHandler',this.userdata.groupType==0,page > 2)
			// 	this.getCompanyList(page);
			// }, 
			getCompanyList(pages) {   
				this.bus.$emit('loading', true); 
				this.page=pages?pages:1; 
				var _this = this;  
				var ajaxurl = this.$api.park.building.list()+'?county='+this.countyid+'&area='+this.streetId+'&kw='+this.searchtext+'&page='+this.page+'&orderField='+this.orderField+'&orderType='+this.orderType;
	 
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('楼宇列表', res.data.list); 
						var dataenterlist= res.data.list; 
						//页数和导出
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize; 
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext; 
						_this.enterpristlist=dataenterlist; 
						_this.bus.$emit('loading', false);
				 
				}).catch(function(error) {});
				// console.log(datas);  
			},
 
			//  
		}
	}
</script>

<style scoped>
	/* .td_sortname{
		width: 96px;padding-left: 2px;padding-right: 25px;
	} */
</style>
